import { useRouter } from 'next/router'
import {
  EventActions,
  EventCategories,
  EventNames,
  sendDigitalDataEvent,
} from '@cinch-nx/shared-analytics'
import { track } from '@cinch-labs/customer-data-segment'
import {
  SectionWithImageV2,
  SectionWithImageV2Props,
} from '@cinch-nx/landing-ui-shared'

const aboutCollectionsPreferDeliveryCtaClick = () => {
  const evt = {
    event: {
      name: EventNames.click,
      category: EventCategories.button,
      action: EventActions.navigate,
      label: 'about-collections-prefer-delivery-cta-click',
    },
  }

  sendDigitalDataEvent(evt)
  track('about-collections-prefer-delivery-cta-click', evt)
}

export const SectionWithImageV2Wrapper: React.FC<SectionWithImageV2Props> = (
  props,
) => {
  const router = useRouter()

  const onClickHandler = () => {
    aboutCollectionsPreferDeliveryCtaClick()
    router.push('/delivery')
  }

  return <SectionWithImageV2 {...props} onButtonClick={onClickHandler} />
}
